import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IListResponse, Nullable } from '@lib/interfaces';
import { TColumn, TColumnSort } from '@lib/modules/table/components';
import { TableModule } from '@lib/modules';
import { BaseComponent } from '@lib/components';
import { CustomersBeneficiaryService } from '@lib/services/customers/customers-beneficiary.service';

@Component({
  selector: 'app-tab-mobile-number',
  standalone: true,
  imports: [CommonModule,TableModule],
  templateUrl: './tab-mobile-number.component.html',
  styleUrls: ['./tab-mobile-number.component.scss']
})
export class TabMobileNumberComponent  extends BaseComponent implements OnInit {

  @Input() customerId = '';
  public mobileNumberList: Array<any> = [];
  public mobileNumberListLoading = false;
  public hasMoreRecords = false;
  protected columns: Array<TColumn> = [
    'name',
    'email',
    'phone',
    'nickname',
    'category',
    'category_display_name',
    'subcategory',
    'subcategory_display_name',
    'instrument_currency',
    'instrument_type',
    'instrument_value',
    'is_deleted',
    'status',
    'created'
  ];
  protected defaultColumns: Array<string> = ['name', 'email', 'phone', 'status', 'created'];
  protected sortableColumns: Array<string> = ['created'];

  constructor(private customerBeneficiaryService:CustomersBeneficiaryService){
    super();
  }
  private fetchMobileNumbers(limit = 10): void {
    this.addSubscription(
        this.customerBeneficiaryService.getBeneficiaryDetails(this.customerId,'Mobile_Transfer').subscribe({
            next: (aliasListResponse: IListResponse<any>): void => {
                this.hasMoreRecords = aliasListResponse.has_more;
                this.mobileNumberList = [...aliasListResponse.data];
                this.mobileNumberListLoading = false;
            },
            error: (): void => {
                this.mobileNumberListLoading = false;
            },
        }),
    );
  }

  ngOnInit(): void {
    this.mobileNumberListLoading = true;
    this.fetchMobileNumbers(10);
  }
}
